/**
 * Kontrol — 4-sink analytics dispatcher.
 *
 * Vanilla-JS port of /Users/kaelsultan/Documents/kontrol-rebuild/lib/analytics/index.ts
 * Keep these two files in sync if the kontrol-rebuild dispatcher changes.
 *
 * Public API:
 *   window.kontrolTrack(event, props, opts)
 *
 * Sinks:
 *   1. GA4   — via window.gtag (loaded by GTM container)
 *   2. Meta  — window.fbq
 *   3. TikTok — window.ttq
 *   4. Server beacon — navigator.sendBeacon to https://homekontrol.net/api/track
 *
 * Spec: docs/superpowers/specs/2026-05-20-shopify-tracking-port-design.md §4.2
 */
(function () {
  "use strict";

  var META_PIXEL_ID = window.KONTROL_META_PIXEL_ID || "1788926768404146";
  var BEACON_URL    = "https://homekontrol.net/api/track";

  var ga4Map = {
    page_view:      "page_view",
    add_to_cart:    "add_to_cart",
    begin_checkout: "begin_checkout",
    purchase:       "purchase",
    whatsapp_click: "WhatsApp_click",
    phone_click:    "click_to_call",
    contact_submit: "lead",
    reserve_click:  "reserve_click",
    review_click:   "review_click",
  };

  var metaMap = {
    page_view:      "PageView",
    add_to_cart:    "AddToCart",
    begin_checkout: "InitiateCheckout",
    purchase:       "Purchase",
    whatsapp_click: "Contact",
    phone_click:    "Contact",
    contact_submit: "Lead",
    reserve_click:  "AddToWishlist",
    review_click:   "ViewContent",
  };

  var tiktokMap = {
    page_view:      "Browse",
    add_to_cart:    "AddToCart",
    begin_checkout: "InitiateCheckout",
    purchase:       "CompletePayment",
    whatsapp_click: "Contact",
    phone_click:    "Contact",
    contact_submit: "SubmitForm",
    reserve_click:  "ClickButton",
    review_click:   "ViewContent",
  };

  function normalizeUser(user) {
    var out = { ga4: {}, meta: {}, tiktok: {} };

    if (user.email) {
      var email = String(user.email).trim().toLowerCase();
      if (email.length > 0) {
        out.ga4.email = email;
        out.meta.em = email;
        out.tiktok.email = email;
      }
    }

    if (user.phone) {
      var digits = String(user.phone).replace(/\D/g, "");
      if (digits.length >= 6) {
        var intl = digits;
        if (digits.indexOf("972") === 0) intl = digits;
        else if (digits.indexOf("0") === 0) intl = "972" + digits.slice(1);
        out.ga4.phone_number = "+" + intl;
        out.meta.ph = intl;
        out.tiktok.phone_number = "+" + intl;
      }
    }

    var firstName = user.firstName ? String(user.firstName).trim() : "";
    var lastName  = user.lastName  ? String(user.lastName).trim()  : "";
    if (!firstName && !lastName && user.name) {
      var parts = String(user.name).trim().split(/\s+/);
      firstName = parts[0] || "";
      lastName  = parts.slice(1).join(" ") || "";
    }
    if (firstName) { out.ga4.first_name = firstName.toLowerCase(); out.meta.fn = firstName.toLowerCase(); }
    if (lastName)  { out.ga4.last_name  = lastName.toLowerCase();  out.meta.ln = lastName.toLowerCase();  }

    return out;
  }

  function track(event, props, opts) {
    props = props || {};
    opts  = opts  || {};

    // Auto-merge click IDs from attribution.js into props.
    var attribution = (window.kontrolAttribution && window.kontrolAttribution.all()) || {};
    var mergedProps = Object.assign({}, props, attribution);

    var user = opts.user ? normalizeUser(opts.user) : null;

    // SINK 1 — GA4 via gtag (loaded by GTM)
    if (typeof window.gtag === "function") {
      if (user && Object.keys(user.ga4).length > 0) {
        window.gtag("set", "user_data", user.ga4);
      }
      window.gtag("event", ga4Map[event], mergedProps);
    }

    // SINK 2 — Meta Pixel
    if (typeof window.fbq === "function") {
      if (user && Object.keys(user.meta).length > 0) {
        window.fbq("init", META_PIXEL_ID, user.meta);
      }
      if (opts.eventId) {
        window.fbq("track", metaMap[event], mergedProps, { eventID: opts.eventId });
      } else {
        window.fbq("track", metaMap[event], mergedProps);
      }
    }

    // SINK 3 — TikTok Pixel
    if (window.ttq && typeof window.ttq.track === "function") {
      if (user && Object.keys(user.tiktok).length > 0 && typeof window.ttq.identify === "function") {
        window.ttq.identify(user.tiktok);
      }
      window.ttq.track(tiktokMap[event], mergedProps);
    }

    // SINK 4 — Server beacon (cross-origin to homekontrol.net)
    try {
      var eventId = opts.eventId || event + ":" + Date.now() + ":" + Math.random().toString(36).slice(2, 8);
      var payload = { event: event, props: mergedProps, eventId: eventId, ts: Date.now() };
      if (navigator.sendBeacon) {
        var blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
        navigator.sendBeacon(BEACON_URL, blob);
      } else {
        fetch(BEACON_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
          keepalive: true,
          mode: "cors",
        }).catch(function () {});
      }
    } catch (e) {
      // Beacons are best-effort; never let them throw into user code.
    }
  }

  window.kontrolTrack = track;
})();
